export default __webpack_public_path__ + "static/media/CampaingsMeasure.491afccb.svg";